import {
    CaseReducer,
    createAsyncThunk,
} from '@reduxjs/toolkit'
import {
    NinchatActionType,
    NinchatUpdateMemberAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
    NinchatClientPromiseValue,
} from '../NinchatClient'
import {channelMemberUpdated} from '../event/channelMemberUpdated'
import {realmMemberUpdated} from '../event/realmMemberUpdated'

const actionTypePrefix = 'NINCHAT/action'

type MetaReducerAsyncThunkConfig = {fulfilledMeta: {reducer: CaseReducer}}

export const updateMember = createAsyncThunk<NinchatClientPromiseValue, NinchatActionParams<NinchatUpdateMemberAction>, MetaReducerAsyncThunkConfig>(
    `${actionTypePrefix}/${NinchatActionType.NinchatUpdateMemberAction}`,
    async (arg, thunkAPI) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatUpdateMemberAction

        const meta = {reducer: params.channel_id ? channelMemberUpdated : params.realm_id ? realmMemberUpdated : () => undefined}

        try {
            const reply = await ninchatClient.send(params)

            return thunkAPI.fulfillWithValue(reply, meta)
        } catch (err) {
            return thunkAPI.rejectWithValue(err)
        }
    },
)
